var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.22147 7.98694C5.08176 7.97317 3.44676 7.23946 2.04222 5.97548C1.54153 5.52491 1.1086 4.99732 0.659348 4.49185C0.437213 4.24196 0.430707 4.02039 0.616395 3.77833C1.65448 2.42544 2.89564 1.31909 4.51285 0.709821C6.82086 -0.159655 8.99493 0.172124 11.0331 1.51728C11.9395 2.11557 12.6918 2.88034 13.3533 3.73705C13.5546 3.99782 13.5682 4.20775 13.3787 4.45373C12.3215 5.82578 11.0524 6.93071 9.40672 7.54399C9.05212 7.67621 8.6842 7.78651 8.31288 7.85625C7.88259 7.93713 7.44182 7.96213 7.22147 7.98694ZM7.00924 6.84978C8.49592 6.84709 9.73972 5.60085 9.74008 4.11361C9.74038 2.60859 8.4975 1.3687 6.99161 1.3717C5.50041 1.3747 4.2626 2.61489 4.26199 4.1067C4.26138 5.61198 5.50371 6.85248 7.00924 6.84978Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.01279 2.63771C7.82015 2.64122 8.47486 3.30228 8.47303 4.11218C8.4713 4.91151 7.79961 5.58336 7.00237 5.58336C6.18438 5.58331 5.52144 4.91395 5.52738 4.09414C5.53318 3.29883 6.21102 2.6342 7.01279 2.63771Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.8d8cdd1243e1dfd6684c5b6de11952da.svg";
export { ForwardRef as ReactComponent };